import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';
import { MsalService } from "@azure/msal-angular";

@Injectable({
  providedIn: 'root',
})
export class TramiteGuard implements CanActivate {
  constructor(
    private router: Router,
    private authB2c: MsalService,
    private authService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if(!this.authB2c){
      this.authService.logout();
    }

    const currentUser:any = this.authService.currentUserValue;
    if (currentUser && currentUser.authToken) {
      if (
        currentUser.TipoDeUsuario === 'Empresa' ||
        currentUser.TipoDeUsuario === 'Afiliado' ||
        currentUser.TipoDeUsuario === 'Windows' ||
        currentUser.TipoDeUsuario === 'No_Afiliado'
      ) {
        if (currentUser.TipoDeUsuario === 'Windows') {
          if (currentUser.windowsRoles.indexOf('Subsidio') > -1) {
            return true;
          } else if (currentUser.windowsRoles.indexOf('Admin') > -1) {
            this.router.navigate(['/administracion']);
            return false;
          } else if (currentUser.windowsRoles.indexOf('Consulta') > -1) {
            this.router.navigate(['/consultas']);
            return false;
          }
        } else {
          return true;
        }
      }
    }
    this.router.navigate(['/login']);
    return false;
  }
}
